import script from "./DeleteAttributeConfirmDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteAttributeConfirmDialog.vue?vue&type=script&setup=true&lang=js"

import "./DeleteAttributeConfirmDialog.vue?vue&type=style&index=0&id=649bc6b1&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-649bc6b1"]])

export default __exports__